export default "__VITE_ASSET__1b51da57__"